import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-55730883")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_fa = _resolveComponent("fa")
  const _component_v_date_picker = _resolveComponent("v-date-picker")

  return (_openBlock(), _createBlock(_component_v_date_picker, {
    class: "input-date",
    modelValue: _ctx.date,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.date = $event))
  }, {
    default: _withId(({ inputValue, togglePopover }) => [
      _createVNode("div", {
        class: "box",
        disabled: _ctx.disabled
      }, [
        _createVNode("input", {
          value: inputValue,
          onClick: ($event: any) => (togglePopover()),
          readonly: "",
          disabled: _ctx.disabled
        }, null, 8, ["value", "onClick", "disabled"]),
        _createVNode("button", {
          class: "",
          onClick: ($event: any) => (togglePopover()),
          disabled: _ctx.disabled
        }, [
          _createVNode(_component_fa, { icon: ['far', 'calendar-alt'] })
        ], 8, ["onClick", "disabled"])
      ], 8, ["disabled"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
})